<template>
  <div>
    <v-container v-if="!initialSetup" fluid class="mb-10">
      <square-loader :color="loaderColor" :size="loaderSize"></square-loader>
      <h3 class="text-center">{{ loadingMessage }}</h3>
    </v-container>
    <v-container v-else>
      <div class="row">
        <div
          class="col-md-3 col-sm-3 col-xs-12"
        >
          <v-card outlined>
            <v-card-title>Filters</v-card-title>
            <v-divider></v-divider>
            <template>
              <v-treeview :items="categories" :open="[1]" :selected-color="'#fff'" activatable open-on-click dense></v-treeview>
            </template>
            <v-divider></v-divider>
            <v-card-title>Price</v-card-title>
            <v-range-slider
              v-model="range"
              :max="maxPrice"
              :min="minPrice"
              :height="10"
              class="align-center"
              dense
            ></v-range-slider>
            <v-row class="pa-2" dense>
              <v-col cols="12" sm="5">
                <v-text-field
                  :value="range[0]"
                  label="Min"
                  outlined
                  dense
                  @change="$set(range, 0, $event)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p class="pt-2 text-center">TO</p>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  :value="range[1]"
                  label="Max"
                  outlined
                  dense
                  @change="$set(range, 1, $event)"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="pb-0">Customer Rating</v-card-title>
            <v-container class="pt-0"  fluid>
              <v-checkbox append-icon="mdi-star" label="4 & above" hide-details dense></v-checkbox>
              <v-checkbox append-icon="mdi-star" label="3 & above" hide-details dense></v-checkbox>
              <v-checkbox append-icon="mdi-star" label="2 & above" hide-details dense></v-checkbox>
              <v-checkbox append-icon="mdi-star" label="1 & above" hide-details dense></v-checkbox>
            </v-container>
            <v-divider></v-divider>

          </v-card>
        </div>
        <div
          class="col-md-9 col-sm-9 col-xs-12"
        >
        <disclaimer />

<!--          <v-breadcrumbs class="pb-0" :items="breadcrums"></v-breadcrumbs>-->

          <v-row dense>
            <v-col cols="12" sm="8" class="pl-6 pt-6">
              <small>Showing 1- {{perPage}} of {{totalProductCount}} product(s)</small>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select class="pa-0" v-model="select" :items="options" style="margin-bottom: -20px;" outlined dense></v-select>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <div class="row text-center">
            <p>{{searchItem}}</p>
            <div class="col-md-3 col-sm-6 col-xs-12" :key="pro.id" v-for="pro in visiblePages">
              <v-hover v-slot:default="{ hover }">
                <v-expand-transition>
                    <appProductCard
                      :name="pro.title"
                      :type="pro.type"
                      :image="pro.image"
                      :price="pro.price"
                      :url="pro.url"
                      :priceRange="range"
                      :hover="hover"
                      @itemPrice="appendPrice"
                    ></appProductCard>
                </v-expand-transition>

              </v-hover>
            </div>
          </div>
          <div class="text-center mt-12">
            <v-pagination
              v-model="page"
              :length=lengthOfPageDisplay
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
import ProductCard from "../components/ProductCard";
// import Disclaimer from '@/components/Disclaimer';
import Disclaimer from '../components/Disclaimer.vue';
export default {
  name: "LandingPage",
  components: {
    appProductCard: ProductCard,
    Disclaimer,
    SquareLoader
  },
  data: () => ({
    initialSetup: false,
    loaderColor:'#2d3753',
    loaderSize: '80px',
    loadingMessage: "Hold on while we set things up",
    range: [0, 10000],
    allPrices: [],
    maxPrice: 0,
    minPrice: 0,
    select:'Popularity',
    options: [
      'Default',
      'Popularity',
      'Relevance',
      'Price: Low to High',
      'Price: High to Low',
    ],
    page:1,
    perPage: 10,
    totalProductCount: null,
    lengthOfPageDisplay: 1,
    breadcrums: [
      {
        text: 'Home',
        disabled: false,
        href: 'breadcrumbs_home',
      },
      {
        text: 'Clothing',
        disabled: false,
        href: 'breadcrumbs_clothing',
      },
      {
        text: 'T-Shirts',
        disabled: true,
        href: 'breadcrumbs_shirts',
      },
    ],
    categories: [],
    items: [
      {
        id: 2,
        name: 'Shoes',
        children: [
          { id: 2, name: 'Casuals' },
          { id: 3, name: 'Formals' },
          { id: 4, name: 'Sneakers' },
        ],
      },
      {
        id: 1,
        name: 'Clothing',
        children: [
          { id: 5, name: 'Shirts' },
          { id: 6, name: 'Tops' },
          { id: 7, name: 'Tunics' },
          { id: 8, name: 'Bodysuit' },
        ],
      }
    ],
    shopProducts: null,
  }),
  created() {
    this.getProducts()
    this.getCategories()
    this.initialSetup = true
  },
  computed: {
    visiblePages () {
      return this.shopProducts
    },
    minPrice(){
      return Math.min(...this.allPrices)
    },
    searchItem(){
      return this.$store.getters.searchTerm
    }
  },
  methods:{
    getProducts(){
      axios.get('products/').then(res =>{
        this.shopProducts =  res.data.results
        this.totalProductCount = res.data.count
        this.productPagination()
      }).catch(error =>{console.log(error)})

    },
    productPagination(){
      // if product count is less than the api provided of 10
      if (this.shopProducts < this.perPage){
        this.lengthOfPageDisplay = 1
      }else{
        this.lengthOfPageDisplay = Math.ceil(this.totalProductCount / this.perPage)
      }
    },
    getCategories(){
      axios.get('categories/').then(res =>{
        this.categories =  res.data.results
        res.data.results.forEach(category =>{
          this.getCategoryChildren(category.name, category.children)
        })
      }).catch(error =>{console.log(error)})
    },
    getCategoryChildren(categoryName, CategoryChildrenUrl){
      axios.get(CategoryChildrenUrl).then(res =>{
        //* override initial category data with new object with children
        this.categories = this.categories.map(obj =>
          obj.name === categoryName ? { ...obj, children: res.data.results } : obj
        );

        return res.data.results
      }).catch(error =>{
        console.log(error)
      })

    },
    appendPrice(prodPrice){
      this.allPrices.push(prodPrice.incl_tax)
      this.maxPrice = Math.max(...this.allPrices)
      this.minPrice = Math.min(...this.allPrices)
      this.range = [this.minPrice, this.maxPrice]
    },
    getProductsOfPage(pageUrl){
      axios.get(pageUrl).then(res =>{
        this.shopProducts =  res.data.results
        this.totalProductCount = res.data.count
        this.productPagination()
      }).catch(error =>{console.log(error)})
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/Views/LandingPage.vue